export default "__VITE_ASSET__DAoog$9O__"